<template>
  <v-card class="segmentos-card">
    <v-container class="pa-0" fluid>
      <v-row no-gutters class="segmentos-conteudo">
        <v-col cols="6" class="segmentos-left">
          <div class="segmentos-left-content">
            <v-row no-gutters>
              <v-col>
                <h3 class="segmentos-title">Público alvo</h3>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <p v-if="localTargetingMode !== 'SEGMENTED'" class="segmentos-description">Defina quais consumidores receberão o disparo em sua campanha.</p>
                <p v-else class="segmentos-segment-text">
                  Selecione os clientes que devem receber essa campanha. Só serão contabilizados na segmentação abaixo clientes que já realizaram o cadastro no
                  seu WhatsApp.
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-radio-group v-model="localTargetingMode" dense hide-details class="mt-0 mb-0">
                  <v-radio style="margin-bottom: 16px !important" label="Todos os contatos" color="primary" value="ALL">
                    <template #label>
                      <span>Todos os contatos</span>
                    </template>
                  </v-radio>
                  <!-- LOYALTY -->
                  <mf-tooltip v-if="isExternalProvider" bottom max-width="250px">
                    <template #activator>
                      <v-radio disabled label="Contatos no clube" color="primary" value="LOYALTY" class="pb-2">
                        <template #label>
                          <span>Contatos no clube</span>
                        </template>
                      </v-radio>
                    </template>
                    <span>Não é possível realizar envios massivos apenas para contatos dentro do clube.</span>
                  </mf-tooltip>
                  <v-radio v-else label="Contatos no clube" color="primary" value="LOYALTY">
                    <template #label>
                      <span>Contatos no clube</span>
                    </template>
                  </v-radio>
                  <!-- NON LOYALTY -->
                  <mf-tooltip v-if="isExternalProvider" bottom max-width="250px">
                    <template #activator>
                      <v-radio disabled label="Contatos fora do clube" color="primary" value="NON_LOYALTY" class="pb-2">
                        <template #label>
                          <span>Contatos fora do clube</span>
                        </template>
                      </v-radio>
                    </template>
                    <span>Não é possível realizar envios massivos apenas para contatos fora do clube.</span>
                  </mf-tooltip>
                  <v-radio v-else label="Contatos fora do clube" color="primary" value="NON_LOYALTY">
                    <template #label>
                      <span>Contatos fora do clube</span>
                    </template>
                  </v-radio>
                  <!-- SEGMENTED -->
                  <mf-tooltip v-if="isExternalProvider" bottom max-width="250px">
                    <template #activator>
                      <v-radio label="Segmentos" color="primary" value="SEGMENTED" class="pb-2">
                        <template #label>
                          <span>Segmentos</span>
                        </template>
                      </v-radio>
                    </template>
                    <span>Para evitar banimentos, envios segmentados são realizados a uma taxa de 60 mensagens por hora por disparador.</span>
                  </mf-tooltip>
                  <v-radio v-else label="Segmentos" color="primary" value="SEGMENTED">
                    <template #label>
                      <span>Segmentos</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="localTargetingMode == 'SEGMENTED'" no-gutters>
              <v-col class="px-4 pb-3">
                <publico-alvo
                  template-type="badge-button"
                  btn-text="Alterar segmento"
                  :segmentos.sync="localChosenSegments"
                  :is-offer-schedule-personalized="isOfferSchedulePersonalized"
                  disable-segment-view
                />
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="6" class="segmentos-informacao">
          <v-container class="pa-0 segmentos-informacao-container" fluid justify-center align-center>
            <v-container v-if="$apollo.queries.numberOfClients.loading || forceLoading" class="pa-0 segmentos-informacao-loading">
              <v-progress-circular class="loader" indeterminate color="primary" />
            </v-container>
            <v-container v-else class="pa-0 segmentos-informacao-inner">
              <v-row no-gutters align="center" class="mb-2">
                <v-col cols="auto">
                  <div class="channel-icon-container">
                    <img src="@/assets/wpp.png" alt="WhatsApp" class="whatsapp-icon" />
                  </div>
                </v-col>
                <v-col>
                  <span class="segmentos-highlighted">{{ contactsCount | localeString }} contatos</span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <span class="segmentos-regular">{{ descriptionBody }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-col>
      </v-row>

      <!-- SVG separador com curva em S -->
      <div class="s-curve-overlay">
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="100%" viewBox="0 0 27 32" preserveAspectRatio="none">
          <path d="M0 16C13.6 16 27 20 27 32V0C27 12 13.6 16 0 16Z" fill="var(--Cinza-L80, #ECEDF0)" />
        </svg>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'
import { localeString } from '@/config/helpers.js'
import { DateTime } from 'luxon'

const QUERY_GET_SEGMENTS_NUMBER_OF_CLIENTS = gql`
  query GetSegmentsNumberOfClients($segments_ids: [ID!]!, $senders: [String]) {
    getSegmentsNumberOfClients(segments_ids: $segments_ids) {
      total
      whatsapp(senders: $senders)
    }
  }
`

export default {
  components: {
    PublicoAlvo: () => import('@/modules/campanhas/views/components/PublicoAlvo.vue'),
  },
  filters: {
    zeroWhenEmpty(value) {
      if (!value) return 0
      return value
    },
  },
  props: {
    senders: Array,
    chosenSegments: Array,
    totalContacts: Object,
    targetingMode: String,
    forceLoading: Boolean,
    isOfferSchedulePersonalized: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    numberOfClients: {
      total: 0,
      whatsapp: 0,
    },
    updating: false,
  }),
  computed: {
    isExternalProvider() {
      return this.$getAllowedModules()['external_whatsapp_provider']
    },
    localTargetingMode: {
      get() {
        return this.targetingMode
      },
      set(value) {
        this.$emit('update:targeting-mode', value)
        this.$emit('update:estimated-max-messages', this.contactsCount)
      },
    },
    localChosenSegments: {
      get() {
        return this.chosenSegments
      },
      set(value) {
        this.$emit('update:chosenSegments', value)
      },
    },
    refreshedSegments() {
      return this.$store.getters.refreshedSegments
    },
    segmentsUpdating() {
      return this.$store.getters.updatingSegmentsIds
    },
    segmentUpdateMessage() {
      let upToDate = true
      this.localChosenSegments.forEach((segmento) => {
        if (DateTime.fromISO(segmento.clients_refreshed_at).toFormat('dd') < DateTime.now().toFormat('dd')) {
          upToDate = false
        }
      })
      if (this.localChosenSegments.length === 1) {
        return `O segmento selecionado está ${upToDate ? 'atualizado' : 'desatualizado'}.`
      }
      return `Os segmentos selecionados estão ${upToDate ? 'atualizados' : 'desatualizados'}.`
    },
    contactsCount() {
      switch (this.localTargetingMode) {
        case 'ALL':
          return this.isExternalProvider ? this.totalContacts.community_total : this.totalContacts.total
        case 'LOYALTY':
          return this.totalContacts.loyalty
        case 'NON_LOYALTY':
          return this.totalContacts.non_loyalty
        case 'SEGMENTED':
          return this.numberOfClients?.whatsapp
      }
      return ''
    },
    descriptionBody() {
      switch (this.localTargetingMode) {
        case 'ALL':
          if (this.isExternalProvider) {
            return 'que formam a base total de contatos das comunidades do Whatsapp para os disparadores selecionados'
          }
          return 'que formam a base total de contatos do Whatsapp para os disparadores selecionados'
        case 'LOYALTY':
          if (this.isExternalProvider) {
            return `dos ${localeString(this.totalContacts.community_total)} contatos da comunidade do Whatsapp, fazem parte do clube de fidelidade`
          }
          return `dos ${localeString(this.totalContacts.total)} contatos do Whatsapp, fazem parte do clube de fidelidade`
        case 'NON_LOYALTY':
          return `dos ${localeString(this.totalContacts.total)} contatos do Whatsapp, não fazem parte do clube de fidelidade`
        case 'SEGMENTED':
          return `dos ${localeString(this.numberOfClients.total)} clientes segmentados, são contatos dos números selecionados`
      }
      return ''
    },
  },
  apollo: {
    numberOfClients: {
      query: QUERY_GET_SEGMENTS_NUMBER_OF_CLIENTS,
      notifyOnNetworkStatusChange: true,
      variables() {
        return {
          segments_ids: this.localChosenSegments.map((segment) => segment._id),
          senders: this.senders,
        }
      },
      skip() {
        if (!this.localChosenSegments || !this.localChosenSegments.length) return true
        return false
      },
      update({ getSegmentsNumberOfClients }) {
        if (getSegmentsNumberOfClients) {
          this.$emit('update:estimated-max-messages', getSegmentsNumberOfClients.whatsapp)
        }
        return getSegmentsNumberOfClients
      },
      fetchPolicy: 'no-cache',
    },
  },
  watch: {
    segmentsUpdating(value) {
      this.updating = value.length > 0

      this.localChosenSegments = this.chosenSegments.map((segment) => {
        if (value.includes(segment._id)) {
          segment.updating = true
        } else {
          segment.updating = false
        }

        return segment
      })
    },
    refreshedSegments(refreshedSegments) {
      this.localChosenSegments = this.chosenSegments.map((segment) => {
        const index = refreshedSegments.findIndex((refreshedSegment) => refreshedSegment._id === segment._id)
        if (index > -1) {
          segment.clients_refreshed_at = refreshedSegments[index].clients_refreshed_at
          segment.clients_qty = refreshedSegments[index].clients_qty
          segment.updating = false
        }
        return segment
      })
      this.updating = false
    },
  },
  methods: {
    removeSegment(index) {
      this.localChosenSegments = this.chosenSegments.filter((segment, segmentIndex) => segmentIndex !== index)
    },
    updateSegments() {
      if (this.updating) return
      this.$store
        .dispatch(
          'updateSegments',
          this.localChosenSegments.map((segment) => segment._id)
        )
        .catch((error) => {
          console.log(error)
          this.$snackbar({
            message: 'Não foi possível atualizar o segmento, tente novamente mais tarde ou entre em contato com o suporte',
            snackbarColor: 'error',
          })
          this.updating = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.segmentos-card {
  height: auto !important;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
}

.s-curve-overlay {
  position: absolute;
  left: calc(50% - 35px);
  top: 0;
  height: 100%;
  width: 35px;
  z-index: 8;
  pointer-events: none;
}

.segmentos-conteudo {
  height: 100%;
  min-height: 240px;
  position: relative;
  width: 100%;

  .segmentos-left {
    background-color: white;
    position: relative;
  }

  .segmentos-informacao {
    background-color: var(--Cinza-L80, #ecedf0);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .segmentos-informacao-container {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .segmentos-informacao-inner {
      padding: 24px 24px 24px 48px;
      text-align: left;
      position: relative;
      z-index: 3;
      margin-left: 40px;

      .v-row {
        height: 100%;

        .v-col {
          display: flex;
          align-items: center;
        }
      }
    }

    .segmentos-informacao-loading {
      width: 160px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .channel-icon-container {
      margin-right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      .whatsapp-icon {
        width: 28px;
        height: 28px;
      }
    }
  }

  .segmentos-left-content {
    position: relative;
    z-index: 3;
    padding: 24px 20px;
  }

  .disabled {
    color: $cinza-0;
  }
}

.segmentos-title {
  color: var(--Cinza-D10, #4b525a);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 21.6px */
  margin: 0 0 8px 0;
}

.segmentos-description {
  font-size: 14px;
  color: #6c757d;
  margin: 0 0 20px 0;
  line-height: 1.4;
}

.segmentos-segment-text {
  font-size: 14px;
  color: #6c757d;
  margin: 0 0 20px 0;
  line-height: 1.4;
}

.segmentos-highlighted {
  color: var(--Cinza-D10, #4b525a);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* Altura fixa para alinhar com o ícone */
  display: flex;
  align-items: center;
  height: 100%;
}

.segmentos-regular {
  color: var(--Cinza-0, #6b7580);
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  display: block;
  margin: 0;
  width: 240px;
  margin-left: 45px;
}

::v-deep .v-radio {
  margin-bottom: 8px !important;

  pointer-events: none;

  .v-label span {
    pointer-events: auto;
    cursor: pointer;
  }

  .v-input--selection-controls__input {
    pointer-events: auto;
    cursor: pointer;
  }

  .v-label {
    color: var(--Cinza-0-Texto-corrido, #6b7580);
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
